import { render, staticRenderFns } from "./advances.vue?vue&type=template&id=0ccd64a5&scoped=true"
import script from "./advances.vue?vue&type=script&lang=js"
export * from "./advances.vue?vue&type=script&lang=js"
import style0 from "./advances.vue?vue&type=style&index=0&id=0ccd64a5&prod&scoped=true&lang=css"
import style1 from "./advances.vue?vue&type=style&index=1&id=0ccd64a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccd64a5",
  null
  
)

export default component.exports